// user-cache.service.ts
import { Injectable } from '@angular/core';
import { UserService } from './user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserCacheService {
  private userSubject = new BehaviorSubject<any>(null);
  user$ = this.userSubject.asObservable();

  constructor(private userService: UserService) {}

  fetchUserDetails(userId: string | number): Observable<any> {
    return this.userService.getUserDetails(userId).pipe(
      tap(user => this.userSubject.next(user))
    );
  }

  getUserDetails(): any {
    return this.userSubject.value;
  }
}
